module.exports = __webpack_public_path__ + "img/SafeWaterLetras.2672af3f.svg";